import { Component, Input, OnInit } from '@angular/core';
import { transferCreditDebitTemplate } from '@finxone-platform/shared/default-templates';
import Handlebars from 'handlebars';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-credit-debit-amount-summary',
  templateUrl: './credit-debit-amount-summary.component.html',
  styleUrls: ['./credit-debit-amount-summary.component.scss'],
})
export class CreditDebitAmountSummaryComponent implements OnInit {
  @Input() balance: number;
  @Input() currency = '';
  @Input() amount: number;
  @Input() template = transferCreditDebitTemplate;

  private handlebarTemplate: HandlebarsTemplateDelegate<any>;

  ngOnInit() {
    this.handlebarTemplate = Handlebars.compile(this.template);
  }

  public renderContent(amount: number): string {
    const result = this.handlebarTemplate({
      amount: amount,
      balance: this.balance,
      difference: this.balance - amount,
      currency: this.currency,
    });
    return result;
  }
}
